import { render } from "./ReservationForm.vue?vue&type=template&id=33c17fce"
import script from "./ReservationForm.vue?vue&type=script&lang=js"
export * from "./ReservationForm.vue?vue&type=script&lang=js"

import "./ReservationForm.vue?vue&type=style&index=0&id=33c17fce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__